export default {
  getDeliveryOrder: (state) => state.deliveryOrder,
};
